<template>
  <div style="min-height: calc(100vh - 176px)" class="flex flex-wrap mt-4">
    <div 
      class="relative py-2 px-2 flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg bg-blueGray-100 border-0" 
      style="min-height: calc(-176px + 100vh);"
    >
      <div class="container mx-auto px-4 py-4">
        <h1 class="text-2xl font-bold mb-4">
          {{ isEditing ? "Редактировать категорию" : "Создать категорию" }}
        </h1>
        <form @submit.prevent="saveCategory" class="bg-white shadow-md rounded px-8 pt-6 pb-8 mb-4">
          <div class="mb-4">
            <label class="block text-gray-700 text-sm font-bold mb-2">Название категории</label>
            <input
              type="text"
              v-model="category.name"
              placeholder="Введите название категории"
              class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
              required
            />
          </div>
          <div class="mb-4">
            <label class="block text-gray-700 text-sm font-bold mb-2">Slug</label>
            <input
              type="text"
              v-model="category.slug"
              placeholder="Введите slug"
              class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
              required
            />
          </div>
          <div v-if="isEditing" class="mb-4">
            <p class="text-gray-600">Дата создания: {{ category.created_at }}</p>
          </div>
          <div class="flex gap-2">
            <button
              type="submit"
              class="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
            >
              Сохранить
            </button>
            <button
              type="button"
              @click="$router.push(backRoute)"
              class="bg-gray-500 hover:bg-gray-700 text-white font-bold py-2 px-4 rounded"
            >
              Назад
            </button>
            <button
              v-if="isEditing && !category.is_delete"
              type="button"
              @click="deleteCategory"
              class="bg-red-500 hover:bg-red-700 text-white font-bold py-2 px-4 rounded"
            >
              Удалить категорию
            </button>
            <button
              v-if="isEditing && category.is_delete"
              type="button"
              @click="restoreCategory"
              class="bg-green-500 hover:bg-green-700 text-white font-bold py-2 px-4 rounded"
            >
              Восстановить категорию
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { API_CATEGORIES, HEADERS_TOKEN_JSON } from "@/const/uri";

export default {
  name: "CategoryEdit",
  data() {
    return {
      category: {
        id: null,
        name: '',
        slug: '',
        content_type: this.$route.params.contentType || this.$route.query.content_type,
        is_delete: false,
        created_at: null,
      },
      isEditing: false,
    };
  },
  computed: {
    backRoute() {
      const contentType = this.$route.params.contentType || this.category.content_type;
      return contentType ? `/admin/category/${contentType}` : '/admin/category';
    }
  },
  mounted() {
    if (this.$route.params.id) {
      this.fetchCategory();
    }
  },
  methods: {
    async fetchCategory() {
      const id = this.$route.params.id;
      const contentType = this.$route.params.contentType || this.$route.query.content_type;
      try {
        const response = await axios.get(
          `${API_CATEGORIES.base}${id}/`,
          { headers: HEADERS_TOKEN_JSON(), params: {
            content_type: contentType,
          }}
        );
        if (response.data.code === 0) {
          this.category = response.data.data;
          this.isEditing = true;
        }
      } catch (error) {
        console.error("Ошибка загрузки категории:", error);
      }
    },
    async saveCategory() {
      try {
        let response;
        if (this.isEditing) {
          response = await axios.put(
            `${API_CATEGORIES.base}${this.category.id}/`,
            this.category,
            { headers: HEADERS_TOKEN_JSON(), params: {
              content_type: this.category.content_type,
            }}
          );
        } else {
          response = await axios.post(
            API_CATEGORIES.base,
            this.category,
            { headers: HEADERS_TOKEN_JSON() }
          );
        }
        if (response.data.code === 0) {
          this.$router.push({ 
            name: "CategoryDetailList",
            params: {
              contentType: this.category.content_type,
            }
          });
        }
      } catch (error) {
        console.error("Ошибка сохранения категории:", error);
      }
    },
    async deleteCategory() {
      if (confirm("Вы уверены, что хотите удалить эту категорию?")) {
        try {
          await axios.delete(
            `${API_CATEGORIES.base}${this.category.id}/`,
            { headers: HEADERS_TOKEN_JSON(), params: {
              content_type: this.category.content_type,
            }}
          );
          this.$router.push({
            name: "CategoryDetailList",
            params: {
              contentType: this.category.content_type,
            }
          });
        } catch (error) {
          console.error("Ошибка удаления категории:", error);
        }
      }
    },
    async restoreCategory() {
      if (confirm("Вы уверены, что хотите восстановить эту категорию?")) {
        try {
          const response = await axios.post(
            `${API_CATEGORIES.base}${this.category.id}/restore/`,
            {},
            { headers: HEADERS_TOKEN_JSON(), params: {
              content_type: this.category.content_type,
            }}
          );
          if (response.data.code === 0) {
            this.$router.push({
              name: "CategoryDetailList",
              params: {
                contentType: this.category.content_type,
              }
            });
          }
        } catch (error) {
          console.error("Ошибка восстановления категории:", error);
        }
      }
    },
  },
};
</script>
